import { render } from "./ImageViewerModal.vue?vue&type=template&id=7724e7a6&scoped=true"
import script from "./ImageViewerModal.vue?vue&type=script&lang=js"
export * from "./ImageViewerModal.vue?vue&type=script&lang=js"

import "./ImageViewerModal.vue?vue&type=style&index=0&id=7724e7a6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7724e7a6"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn,QImg});qInstall(script, 'directives', {ClosePopup});
